import React  from "react";
// { useState, useLayoutEffect } 
import { graphql } from "gatsby";
import { MDXRenderer } from 'gatsby-plugin-mdx'
import { OutboundLink } from "gatsby-plugin-google-gtag"
import Layout from "../components/layout";
import SEO from "../components/seo";


// import getBlog, { formatDate } from "../common/blog.js";

import "../styles/styles.css";

const TeamPage = (context) => {
  
  return (
    <Layout>
      <SEO title="Team" />
      <div className="page-container">
          <h1>Meet the team</h1>
          {
            context.data.allAirtable.nodes.filter(bio => bio.data.DisplayStatus === 'Leader').map((bio) => {
              return <div key={bio.id} className={"teammate-container"}>
                <div className={"image"}>
                  {
                    bio.data.TeammatePhoto && <img alt={bio.data.TeammateName} src={bio.data.TeammateSitePhoto || ''}/>
                  }
                </div>
                <div className="bio">
                  <h1 id={bio.data.TeammateName.split(" ").join("-")}>
                    {bio.data.TeammateName}
                  </h1>
                  <p><strong>{bio.data.TeammateRole}</strong></p>
                  {/* {
                    bio.data.TeammateCategory.map((category) => <span className="category">{category}</span>)
                  } */}
                  {bio.data.TeammateEmail && <p><OutboundLink href={`mailto:${bio.data.TeammateEmail}`}>{bio.data.TeammateEmail}</OutboundLink></p>}
                  {bio.data.TeammateWebsite && (<p><OutboundLink href={new URL( bio.data.TeammateWebsite.startsWith('http://') || bio.data.TeammateWebsite.startsWith('https://') ? bio.data.TeammateWebsite : `http://${bio.data.TeammateWebsite}`).href} target="_blank" rel="noopener noreferrer"> {bio.data.TeammateWebsite}</OutboundLink></p>)}
                  {bio.data.TeammateBio && <MDXRenderer>{bio.data.TeammateBio.childMdx.body}</MDXRenderer>}
                </div>
              </div>
            })
          }
          <h2 className="team-subtitle">Alumni, Contributors and Acknowledgements</h2>
          <div className="member-grid">
            {
              context.data.allAirtable.nodes
                .filter(bio => bio.data.DisplayStatus === 'Member')
                .map(bio => (
                  <div key={bio.id} className="member-card">
                    {
                      bio.data.TeammatePhoto && <img alt={bio.data.TeammateName} src={bio.data.TeammateSitePhoto || ''} loading="lazy"/>
                    }
                    <h3>
                      <strong>{bio.data.TeammateName}</strong>
                    </h3>
                    <p>{bio.data.TeammateRole}</p>
                  </div>
                ))
            }
          </div>
          <div>
            <p>Numerous further contributors have contributed to the success of the Princeton Gerrymandering Project, including but not limited to:</p>
            <ul className="team-list">
              {
              /*
              <li>Brian Remlinger was the first full-time staff member of the Gerrymandering Project. Brian did the first wave of analysis, co-wrote scholarly and popular articles, and played a key role in launching our current activities.</li>
              <li>Hannah Wheelen founded the data group and coordinated its work through the 2021 redistricting cycle. Hannah and Amanda Kmetz developed the methods underlying draft map evaluation and report cards.</li>
              <li>Indraneel Purohit was technology developer and developed many of the backend tools that power this site.</li>
              <li>Zachariah Sippy '23 performed state-by-state political analysis.</li> 
              <li>Will Adler conducted statistical analyses, maintained datasets and software tools, and worked with state-level partners.</li>
              <li>Ben Williams conducted legal analyses, drafted statutes, drew maps, and maintained strategic partnerships.</li>
              <li>Sandra Chen '23 did legislative policy analysis, with a focus on communities-of-interest as a standard for fair districting. She published an article in the Stanford Journal of Civil Rights and Civil Liberties.</li>
              */
              }
              <li>Lafayette College designed our bug logo.</li>
              <li>Adam Podowitz-Thomas was senior legal strategist. Helen Brewer and Aaron Barden were legal analysts.</li>
              <li>Jason Rhode worked on communications and outreach.</li>
              <li>Rob Whitaker designed an earlier verison of our website, including the geographic test explorer.</li>
              <li>Madeleine Parker bolstered our GIS capabilities.</li>
              <li>Aimee Otsu helped improve the user interface of the website.</li>
              <li>Sung Chang did early work on the map visualizer.</li>
              <li>Tim Mack compiled and cleaned our election data.</li>
              <li>John O'Neill assisted with our data collection process and drew some political maps.</li>
              <li>Laura Williamson strengthened our efforts at outreach and partnership with reformers.</li>
              <li>Hope Johnson and Baxter Demers were data analysts.</li>
              <li>Steve Birnbaum did business development.</li>
              <li>Michaela Daniel '22 did outreach for Representable.</li>
              <li>Jesse T. Clark was a postdoctoral researcher. During New Jersey redistricting he was an observer and assisted PGP staff.</li>
              <li>Hayden Goldberg contributed to legal scholarship.</li>
              {/*<li>Joan W. Dunlap was associate director. </li>*/}
            </ul>
          </div>
          <h4>For general inquiries, reach out to us here: <OutboundLink href={`mailto:gerrymander@princeton.edu`}>gerrymander@princeton.edu</OutboundLink>.</h4>
      </div>
    </Layout>
  );
};

export default TeamPage;

export const teamBiosQuery = graphql`
  query teamPageQuery {
    allAirtable(filter: {table: {eq: "Team"}}, sort: {fields: data___TeammateOrder, order: ASC}) {
      nodes {
        id
        data {
          Last_Updated
          TeammateName
          TeammateOrder
          TeammateCategory
          TeammateEmail
          TeammateWebsite
          TeammateRole
          TeammateBio {
            id  
            childMdx {
              body
            }
          }
          TeammateSitePhoto
          DisplayStatus
          TeammatePhoto {
            localFiles {
              id
              url
            }
          }
        }
      }
    }
  }
`;
